import styled from 'styled-components';

export const Wrapper = styled.div`
  color: #f03e3e;
`;
